import { render } from "./time-slots-selector.component.vue?vue&type=template&id=5cc163d3&ts=true"
import script from "./time-slots-selector.component.vue?vue&type=script&lang=ts"
export * from "./time-slots-selector.component.vue?vue&type=script&lang=ts"

import "./time-slots-selector.component.vue?vue&type=style&index=0&id=5cc163d3&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__